import { createAction, props } from "@ngrx/store";
import { ToastError, ToastMessage, ToastSuccess } from "../../models/toast-models";

export const showMessage = createAction(
    `[Toast] onMessage`,
    props<ToastMessage>(),
);

export const showSuccessMessage = createAction(
  `[Toast] show Success Message`,
   props<ToastSuccess>(),
);

export const showErrorMessage = createAction(
  `[Toast] show error message`,
   props<ToastError>(),
);

export const hideMessage = createAction(
    `[Toast] hideMessage`,
    props<ToastMessage>(),
);

export const messageInvoked = createAction(
    `[Toast] messageInvoked`,
);

export const messageQueueInvoked = createAction(
  `[Toast] messageQueueInvoked`,
);
